<script lang="ts" setup>
import { Menu, MenuButton, MenuItems } from '@headlessui/vue'

interface Props {
  x?: 'left' | 'right'
  y?: 'top' | 'bottom'
  maxHeight?: string | null
  menuItemsClasses?: string
}

withDefaults(defineProps<Props>(), {
  x: 'left',
  y: 'bottom',
  maxHeight: null,
  menuItemsClasses: 'bg-white',
})
</script>

<template>
  <Menu v-slot="{ open }" as="div" class="relative">
    <div>
      <MenuButton class="flex items-center">
        <slot name="button" :open="open" />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition duration-300"
      :enter-from-class="
        y === 'top' ? 'translate-y-3 opacity-0' : '-translate-y-3 opacity-0'
      "
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-300"
      leave-from-class="translate-y-0 opacity-100"
      :leave-to-class="
        y === 'top' ? 'translate-y-3 opacity-0' : '-translate-y-3 opacity-0'
      "
    >
      <MenuItems
        class="absolute z-20 mt-2 max-h-60 overflow-y-auto overflow-x-hidden whitespace-nowrap rounded-md text-sm shadow-md"
        :style="maxHeight ? `max-height:${maxHeight}` : undefined"
        :class="{
          'bottom-full': y === 'top',
          'top-full': y === 'bottom',
          'left-0': x === 'left',
          'right-0': x === 'right',
          [menuItemsClasses]: true,
        }"
      >
        <slot name="items" />
      </MenuItems>
    </transition>
  </Menu>
</template>
